import { PageHeader } from '@loop3/ui'
import { LinkSection } from '@/components/knowledge-hub/link-section'
import { KNOWLEDGE_BASE } from '@/lib/knowledge-base'
import { DAILY_TOOLS, INTERNAL_TOOLS } from '@/lib/tools'

/** Knowledge Hub: L3OS tools, the knowledge base and daily tools on one page. */
export function KnowledgeHubPage() {
  return (
    <div className="mx-auto max-w-7xl pb-16">
      <PageHeader
        title="Everything the Loop3 team knows and uses"
        subtitle="Solutions, tools, the company wiki and VC reference material in one place."
        className="mb-10"
      />
      <div className="space-y-14">
        <LinkSection
          label="L3OS Tools"
          unit="tools"
          items={INTERNAL_TOOLS}
          className="sm:grid-cols-2 lg:grid-cols-4"
        />
        <LinkSection
          label="Knowledge Base"
          unit="resources"
          items={KNOWLEDGE_BASE}
          className="sm:grid-cols-3"
        />
        <LinkSection
          label="Internal Tools"
          unit="tools"
          items={DAILY_TOOLS}
          className="sm:grid-cols-3"
        />
      </div>
    </div>
  )
}
